var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c(
                    "w-button",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.goToCalculatedFields()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                    1
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Preloads bewerken",
                              expression: "'Preloads bewerken'",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              _vm.preloadEditorOpen = true
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "spinner" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "save" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "", center: "" } },
        [
          _c(
            "transition",
            { staticClass: "fast-fade", attrs: { mode: "out-in" } },
            [
              !_vm.ready
                ? _c(
                    "w-col",
                    { attrs: { center: "" } },
                    [_c("w-progress-circular")],
                    1
                  )
                : _c(
                    "w-col",
                    { style: { height: "100%" }, attrs: { grow: "" } },
                    [
                      _c(
                        "w-card",
                        {
                          staticClass: "grow",
                          style: { maxHeight: "100%" },
                          attrs: { tag: "w-card" },
                        },
                        [
                          _c(
                            "w-card-title",
                            [
                              _c("w-input", {
                                attrs: { label: "Naam", fancy: "" },
                                model: {
                                  value: _vm.field.Name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.field, "Name", $$v)
                                  },
                                  expression: "field.Name",
                                },
                              }),
                              _c("w-spacer"),
                              _c("w-select", {
                                staticClass: "select",
                                attrs: {
                                  label: "Tabel",
                                  fancy: "",
                                  items: _vm.tableItems,
                                  right: "",
                                },
                                model: {
                                  value: _vm.field.Table,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.field, "Table", $$v)
                                  },
                                  expression: "field.Table",
                                },
                              }),
                              _c("w-select", {
                                staticClass: "select",
                                attrs: {
                                  label: "Return type",
                                  fancy: "",
                                  items: _vm.returnTypeItems,
                                  right: "",
                                },
                                model: {
                                  value: _vm.field.ReturnType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.field, "ReturnType", $$v)
                                  },
                                  expression: "field.ReturnType",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-scroll-view",
                            {
                              staticClass: "grow no-margin",
                              attrs: { tag: "w-col" },
                            },
                            [
                              _c("codemirror", {
                                ref: "codeEditor",
                                staticClass: "grow",
                                attrs: { options: _vm.cmOptions },
                                model: {
                                  value: _vm.field.JsCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.field, "JsCode", $$v)
                                  },
                                  expression: "field.JsCode",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-card-content",
                            { style: { flexGrow: 0, flexShrink: 0 } },
                            [
                              _c(
                                "w-row",
                                [
                                  _c("w-col", { attrs: { xs: "12" } }, [
                                    _c("div", [
                                      _vm._v(
                                        "Calculated fields moeten een unieke naam hebben per tabel en zijn geschreven in javascript."
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "Je kan val gebruiken om het huidige object te lezen."
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "Vergeet niet de preloads te controlleren als je klaar bent."
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.preloadEditorOpen } },
        [
          _vm.preloadEditorOpen
            ? _c("app-dossier-calculated-fields-preload-edit-modal", {
                on: {
                  close: function ($event) {
                    _vm.preloadEditorOpen = false
                  },
                },
                model: {
                  value: _vm.field.Preloads,
                  callback: function ($$v) {
                    _vm.$set(_vm.field, "Preloads", $$v)
                  },
                  expression: "field.Preloads",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }